import React from 'react';
import { Table } from 'element-react';
import Sortable from 'sortablejs';
import 'element-theme-default';

const formatNumber = (num, point=4) => {
    if(num){
        // num = `${parseFloat(num).toFixed(point)}`
        num = `${parseFloat(num)}`
        let num_list = num.split('.')
        if(num_list.length == 2){
            return `${num_list[0].replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')}.${num_list[1]}`;
        }else{
            return num_list[0].replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
        }
    }else{
		if(`${num}`=== '0' || `${num}` === '0.0' ){
			return 0
		}else {
			return ''
		}
    }
};

export default class VueTable extends React.Component{

	constructor(props){
		super(props);
		this.state = {
		    columns: [
				{
					label: '科目代码',
					prop: 'subject',
					width:200,
					align: 'left',
					className:'maxk'
				},
				{
					label: '科目名称',
					prop: 'course',
					width: 200,
					align: 'left',
				},
				{
					label: '数量',
					prop: 'quantity',
					align: 'right',
					width: 160,
					render: function(data){
						return formatNumber(data['quantity'])
					}
				},
				{
					label: '单位成本',
					prop: 'unit',
					align: 'right',
                    width: 120,
                    render: function(data){
						return formatNumber(data['unit'])
					}
				},
				{
					label: '成本',
					prop: 'costing',
					width: 160,
					align: 'right',
					render: function(data){
						return formatNumber(data['costing'])
					}
				},
				{
					label: '成本占净值（%）',
					prop: 'equity',
					align: 'right',
                    width: 180,
                    // render: function(data){
					// 	return formatNumber(data['equity'])
					// }
				},
				{
					label: '市价',
					prop: 'MarketPrice',
					width:160,
					align: 'right',
					render: function(data){
						return formatNumber(data['MarketPrice'])
					}
				},
				{
					label: '市值',
					prop: 'market',
					width:160,
					align: 'right',
					render: function(data){
						return formatNumber(data['market'])
					}
				},
				{
					label: '市值占净值（%）',
					prop: 'MarketValue',
					// width:140,
					align: 'right',
                    width: 180,
                    // render: function(data){
					// 	return formatNumber(data['MarketValue'])
					// }
				},
				{
					label: '估值增值',
					prop: 'valuation',
					align: 'right',
                    width: 140,
                    render: function(data){
						return formatNumber(data['valuation'])
					}
				},
				{
					label: '停牌信息',
					prop: 'suspension',
					align: 'left',
                    width: 140,
				},
				{
					label: '权益信息',
					prop: 'information',
					align: 'left',
                    width: 140,
				},
			],
		    data: this.props.data,
			key: 0
		}
	}

	componentDidMount() {
		this.columnDrop()
	}

	componentDidUpdate(prevProps, prevState) {
		this.columnDrop()
	}

	

	columnDrop = () => {
        const wrapperTr = document.querySelector('.el-table__header tr');
        let { columns } = this.state;
        let self = this;
        this.sortable = Sortable.create(wrapperTr, {
            animation: 180,
            delay: 0,
            onEnd: evt => {
                const oldItem = columns[evt.oldIndex]
                columns.splice(evt.oldIndex, 1)
                columns.splice(evt.newIndex, 0, oldItem)
                self.setState((prev, props) => {
                    return { key: prev.key+1, columns, data: prev.data }
                }, self.columnDrop())
                
            }
        })
    };

    /**
     * 获取第一个表格的可视化高度
     * @param {*} extraHeight 额外的高度(表格底部的内容高度 Number类型,默认为74) 
     * @param {*} id 当前页面中有多个table时需要制定table的id
     */
    getTableScroll = ({ extraHeight, id }) => {
        if (typeof extraHeight == "undefined") {
            //  默认底部分页64 + 边距10   21  的未知
            extraHeight = 20
        }
        let tHeader = null 
        if (id) {
            tHeader = document.getElementById(id) ? document.getElementById(id).getElementsByClassName("el-table__header")[0] : null
        } else {
            tHeader = document.getElementsByClassName("el-table__header")[0]
        }
        //表格内容距离顶部的距离
        let tHeaderBottom = 0
        if (tHeader) {
            tHeaderBottom = tHeader.getBoundingClientRect().bottom
        }
        //窗体高度-表格内容顶部的高度-表格内容底部的高度
        // let height = document.body.clientHeight - tHeaderBottom - extraHeight
        let height = `calc(100vh - ${tHeaderBottom + extraHeight}px)`
        return height
        // console.log('height', height)
        // this.setState((prev, props) => {
        //     return { tableHeight: height }
        // })
    };

	render() {
		return (
			<Table
				className="ValuationsDetails"
				// key={Math.random()}
				style={{width: '100%',height:700}}
				columns={this.state.columns}
				data={this.state.data}
				border={true}
				height={this.getTableScroll({})}
			/>
		)
	}
}



// WEBPACK FOOTER //
// app/components/customPage/Valuation/VueTable.jsx